import Select, { components } from "react-select";
import React from "react";

const Option = (props, className) => {
  return (
    <div>
      <components.Option {...props}>
        <div className="flex items-center space-x-2  ">
          <input
            className={`flex items-center space-x-2 hover:bg-white${className}`}
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />
          <label className="">{props.label}</label>
        </div>
      </components.Option>
    </div>
  );
};
const customStyles = {
  multiValueRemove: (provided) => ({
    ...provided,
    display: "none",
  }),
  multiValue: (provided) => ({
    ...provided,
    textOverflow: "ellipsis",
    maxWidth: "70%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    display: "initial",
    backgroundColor: "transparent",
    padding: "0",
  }),
  option: (provided, state) => ({
    ...provided,
    active: "",
    padding: "3px",
    color: "black",
    backgroundColor: "white",
    fontSize: "12px",
  }),

  control: (provided, state) => ({
    ...provided,
    background: "#fff",
    //borderColor: "#d1d5db",
    border: "0",
    minHeight: "26px",
    height: "26px",
    boxShadow: state.isFocused ? null : null,
  }),

  valueContainer: (provided, state) => ({
    ...provided,
    height: "26px",
    padding: "0px 6px",
  }),

  input: (provided, state) => ({
    ...provided,
    margin: "0px",
  }),
  dropdownIndicator: () => ({
    color: "#212121",
    svg: {
      height: "15px",
    },
  }),
  indicatorSeparator: (state) => ({
    display: "none",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: "26px",
    margin: "0px",
  }),

  menu: (provided, state) => ({
    ...provided,
    overflowX: "auto",
    paddingLeft: "10px",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

const valueContainer = ({ children, ...props }) => {
  let [values, input] = children;
  if (Array.isArray(values)) {
    values =
      values.length > 1
        ? values.length === props.options.length
          ? "ALL"
          : `Selected (${values.length}) `
        : values;
  }

  return (
    <components.ValueContainer {...props}>
      {values}
      {input}
    </components.ValueContainer>
  );
};
const SelectHookForm_3 = ({
  field,
  defaultValue,
  options,
  isDisabled,
  className,
  label,
  validation,
  onChange, // send value to hook form
  value = [],
  isMulti = true,
  secondDiv = "md:grid-cols-3 items-center",
  isLoading,
}) => {
  return (
    <div className="space-y-1 w-full text-xs">
      <div className={`grid ${secondDiv} w-full items-start gap-1`}>
        {label && (
          <label
            className={`flex items-stretch text-left expandedLabel fontExpand`}
          >
            {validation && validation.required && (
              <span className="text-red-500 font-bold">*</span>
            )}
            {label}:{" "}
          </label>
        )}

        <Select
          className={`${
            className ? className : "border border-gray-300 col-span-2"
          } rounded-sm text-xs focus:ring-quaternary focus:border-quaternary  ${
            isDisabled && "opacity-20 "
          }`}
          {...field}
          onChange={onChange}
          // onChange={(selected, event) => {
          //   if (
          //     event.action === "deselect-option" &&
          //     event.option.value === "ALL" //TOGGLE SELECT ALL
          //   ) {
          //     return onChange(null);
          //   }
          //   return onChange(selected);
          // }}
          value={
            value
              ? value?.find((x) => x.value?.toUpperCase() === "ALL")
                ? options
                : value
              : null
          }
          options={options}
          isMulti={isMulti}
          isSearchable
          isClearable
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          styles={customStyles}
          isDisabled={isDisabled}
          components={
            isMulti
              ? {
                  ValueContainer: valueContainer,
                  Option,
                }
              : ""
          }
          tabSelectsValue={false}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default SelectHookForm_3;
